import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';
import { Badge } from 'flowbite-react';
import Axois from '../utils/axios';
import dayjs from 'dayjs';
import { useOutletContext } from 'react-router-dom';
import usePaymentAPI from '../apis/paymentAPI';



const MyFooter = ({ handleSell, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSell} type='primary'>CREATE PAYMENT</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};


const RegisterPaymentModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const { success } = useOutletContext();
  const [journals, setJournals] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [someData, setSomeData] = useState({});
  const [partnerType, setPartnerType] = useState('');
  const [amount, setAmount] = useState(0);
  const [creditNote, setCreditNote] = useState(false);
  const { registerPayment } = usePaymentAPI();

  const onChangeJournal = option => {
    if (partnerType === 'vendor') {
      setPaymentMethod(option.out_payment);
    }else if (partnerType === 'customer') {
      setPaymentMethod(option.in_payment);
    }
    form.setFieldValue('journal', option.label.toLowerCase()); 
  }

  
  const handleCancel = () => {
    setIsModalOpen(false);
    // form.resetFields();
    // form.
  }
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  
  

  useEffect(() => {
    EventEmitter.subscribe('register_payment', data => {
      setIsModalOpen(data.open);
      delete data.open;
      setSomeData(data);
      form.setFieldValue('memo', data.number);
      form.setFieldValue('amount', data.amount);
      setAmount(data.amount);
      // setCreditNote(data.credit_note);
      setPartnerType(data.partner_type);
      console.log(data);
    });

    EventEmitter.subscribe("populate_payment", data => form.setFieldsValue(data));

    return () => {
      EventEmitter.unsubscribe('register_payment');
      EventEmitter.unsubscribe('populate_payment');
    }
  },[]);


  useEffect(() => {
    Axois.get('setups/register_payment')
    .then(res => {
      setJournals(res.data.journals);
      setAccounts(res.data.accounts);
      const payment = res.data.journals.find(journal => journal._id === 'dOst4ZWka3Mj7i2NU0sLv93hkfm1mQe3Tg');
      // form.setFieldValue('account_id', payment.default_account);
      setPaymentMethod(payment.in_payment_method);
      console.log(res.data.journals)
    })
    .catch(err => console.log(err))
  },[])

  // console.log(journals);

  const handleRegisterPayment = async () => {
    try {
      let data = form.getFieldsValue();
      // let journal = form.getFieldValue('journal');
      data['date'] = new Date(data.date).toLocaleDateString();
      // const payMethod = paymentMethod.find(payment => payment.method === data.payment_method);
      // data['account_id'] = payMethod.outstanding_account_id;
      data['partner_id'] = someData.partner_id;
      // if (journal === 'bank') {
      //   data['status'] = 'in payment';
      // }else {
      //   data['status'] = data.amount === amount ? 'full' : 'partial';
      // }
      // setIsModalOpen(false);
      // console.log(data);
      await registerPayment(`${partnerType === 'customer' ? '/invoice' : partnerType === 'vendor' && '/vendor-bills'}/register-payment`, data)
    }catch (err) {
      console.log(err);
    }
  }


  return (
    <Modal title="Register Payment" width={900} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSell={handleRegisterPayment}/>}>
      <Form
        form={form}
        className='border-t-2 py-5' 
        labelAlign='left'
        labelCol={{span: 9}}
        initialValues={{ payment_method: 'manual', date: dayjs(), journal_id: 'dOst4ZWka3Mj7i2NU0sLv93hkfm1mQe3Tg'}}
        autoComplete="off"
        variant='borderless'
      >
        <Row className='mt-5'>
          <Col md={{span: 11}}>
            <Form.Item label='Journal' name="journal_id" className='font-semibold text-gray-800 mb-2' required>
              <Select options={journals.map(journal => ({value: journal._id, label: journal.name, in_payment: journal.in_payment_method, out_payment: journal.in_payment_method}))} onChange={(v, option)=>onChangeJournal(option)}/>
            </Form.Item>
            <Form.Item label='Payment Method' name="payment_method" className='font-semibold text-gray-800 mb-2' required>
              <Select options={paymentMethod.map(payment => ({value: payment.method, label: payment.name}))} />
            </Form.Item>
            {/* <Form.Item label='Account' name="account_id" className='font-semibold text-gray-800 mb-2' required>
              <Select options={accounts.map(account => ({value: account._id, label: `${account.code} ${account.name}`}))}/>
            </Form.Item> */}
          </Col>
          <Col md={{span: 11, offset:1}}>
            <Form.Item label='Amount' name={'amount'} className='font-semibold column mb-2' required >
              <InputNumber className='w-full'/>
            </Form.Item>
            <Form.Item label='Payment Date' name={'date'} className='font-semibold mb-2' required >
              <DatePicker className='w-full'/>
              </Form.Item>
            <Form.Item label="Memo" name="memo" className='font-semibold mb-2' required >
              <Input type='text' className='input-outline-none font-normal' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default RegisterPaymentModal;